import React from "react";
import { Building2, Globe2, Hash, Mail, Phone, User } from "lucide-react";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FieldLabel, SectionLabel } from "./FormPrimitives";

export const TRADE_LANES = ["China to Dubai", "Dubai to Iraq", "China to EU", "China to KSA"];

export const CustomerDetailsCard = ({ form, setField, onShortCodeChange }) => (
  <Card className="border-zinc-200 shadow-sm">
    <div className="p-6 md:p-8">
      <SectionLabel hint="Step 1 / 5">Customer Details</SectionLabel>

      <div className="mb-4">
        <FieldLabel htmlFor="trade_lane" icon={Globe2}>
          Trade Lane <span className="text-red-600">*</span>
        </FieldLabel>
        <Select value={form.trade_lane || ""} onValueChange={(v) => setField("trade_lane", v)}>
          <SelectTrigger className="h-11" data-testid="select-trade-lane-trigger">
            <SelectValue placeholder="Select route (e.g. China to Dubai)" />
          </SelectTrigger>
          <SelectContent>
            {TRADE_LANES.map((tl) => (
              <SelectItem key={tl} value={tl} data-testid={`trade-lane-${tl.replace(/\s/g, "-")}`}>
                {tl}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <FieldLabel htmlFor="customer_name" icon={User}>Customer Name</FieldLabel>
          <Input id="customer_name" data-testid="input-customer-name" placeholder="e.g. John Smith" value={form.customer_name} onChange={(e) => setField("customer_name", e.target.value)} className="h-11" />
        </div>
        <div>
          <FieldLabel htmlFor="company_name" icon={Building2}>Company Name</FieldLabel>
          <Input id="company_name" data-testid="input-company-name" placeholder="e.g. Acme Logistics" value={form.company_name} onChange={(e) => setField("company_name", e.target.value)} className="h-11" />
        </div>
        <div>
          <FieldLabel htmlFor="mobile_number" icon={Phone}>Mobile Number</FieldLabel>
          <Input id="mobile_number" data-testid="input-mobile-number" placeholder="+91 98XXXXXX00" value={form.mobile_number} onChange={(e) => setField("mobile_number", e.target.value)} className="h-11" />
        </div>
        <div>
          <FieldLabel htmlFor="email" icon={Mail}>Email ID</FieldLabel>
          <Input id="email" type="email" data-testid="input-email" placeholder="name@company.com" value={form.email} onChange={(e) => setField("email", e.target.value)} className="h-11" />
        </div>
        <div>
          <FieldLabel htmlFor="short_code" icon={Hash}>Customer Short Code</FieldLabel>
          <Input id="short_code" data-testid="input-short-code" placeholder="e.g. ACME" value={form.customer_short_code} onChange={onShortCodeChange} className="h-11 font-mono tracking-wider uppercase" />
        </div>
        <div>
          <FieldLabel htmlFor="en_no" icon={Hash}>EN NO</FieldLabel>
          <Input id="en_no" data-testid="input-en-no" placeholder="e.g. EN-2026-0042" value={form.en_no} onChange={(e) => setField("en_no", e.target.value)} className="h-11 font-mono" />
        </div>
      </div>
      <p className="text-[11px] text-zinc-500 mt-3 font-mono">
        Sequence number is appended live (e.g. ACME1, ACME2…). EN NO appears small in the bottom-left of the label.
      </p>
    </div>
  </Card>
);
